// ets_tracing: off
import { first } from "@effect-ts/core/Associative";
import { difference, Foldable as foldableArray, intersection } from "@effect-ts/core/Collections/Immutable/Array";
import { fromFoldable as RfromFoldable, mapWithIndex as RmapWithIndex } from "@effect-ts/core/Collections/Immutable/Dictionary";
import { tuple } from "@effect-ts/core/Collections/Immutable/Tuple";
import * as Equal from "@effect-ts/core/Equal";
import { makeADT } from "../../../Adt/index.mjs";
import { assignCallable, wrapFun } from "../utils/index.mjs";
const recordFromArray = /*#__PURE__*/RfromFoldable( /*#__PURE__*/first(), foldableArray);

const keepKeys = (a, toKeep) => recordFromArray(intersection(Equal.string)(toKeep)(Object.keys(a)).map(k => tuple(k, a[k])));

const excludeKeys = (a, toExclude) => recordFromArray(difference(Equal.string)(toExclude)(Object.keys(a)).map(k => tuple(k, a[k])));

export function makeTagged(summ) {
  return tag => (o, config) => {
    const summoned = summ(F => F.taggedUnion(tag, RmapWithIndex((_k, v) => v(F))(o), config));
    const adt = makeADT(tag)(o);
    const preTagged = makeTagged(summ)(tag);

    const selectMorph = (selectedKeys, c) => preTagged(keepKeys(o, selectedKeys), {
      name: (c === null || c === void 0 ? void 0 : c.name) || (config === null || config === void 0 ? void 0 : config.name),
      conf: { ...(config === null || config === void 0 ? void 0 : config.conf),
        ...(c === null || c === void 0 ? void 0 : c.conf)
      }
    });

    const excludeMorph = (selectedKeys, c) => preTagged(excludeKeys(o, selectedKeys), {
      name: (c === null || c === void 0 ? void 0 : c.name) || (config === null || config === void 0 ? void 0 : config.name),
      conf: { ...(config === null || config === void 0 ? void 0 : config.conf),
        ...(c === null || c === void 0 ? void 0 : c.conf)
      }
    });

    const res = assignCallable(wrapFun(summoned), { ...summoned,
      ...adt,
      selectMorph,
      excludeMorph
    });
    return res;
  };
}
//# sourceMappingURL=index.mjs.map